export const DriveSubMenuRoutes = {
  DEFAULT: '/my-drive',
  MY_DRIVE: '/my-drive',
  SHARED_WITH_ME: '/shared-with-me',
};
